import React, { createContext, useContext } from 'react';
import { errorMessageDuplicateCommonCore } from '../constants';
const RequestTypeApiContext = /*#__PURE__*/createContext(null);
export const RequestTypeApiProvider = ({
  requestTypeApi,
  children
}) => /*#__PURE__*/React.createElement(RequestTypeApiContext.Provider, {
  value: requestTypeApi
}, children);
export const useRequestTypeApi = () => {
  const requestTypeApi = useContext(RequestTypeApiContext);
  if (requestTypeApi === null) {
    throw new Error(`useRequestTypeApi() must be used within a RequestTypeApiProvider. ${errorMessageDuplicateCommonCore}`);
  }
  return requestTypeApi;
};